import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useProjectState = () => React.useContext(Context)
export const useProject = () => useProjectState()?.project

const QUERY = gql`
  query Project($id: ID, $fromTemplates: Boolean) {
    project(id: $id, fromTemplates: $fromTemplates) {
      id
      name
      color
      icon
    }
  }
`

const ProjectLoader = ({ children }) => {
  const { id, fromTemplates } = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id, fromTemplates },
    skip: !id,
    client: accountsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ProjectLoader
